import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import { useSetRecoilState } from "recoil";

import {
  fetchWisudaTerdaftar,
  showWisudaTerdaftar,
  getWisudaDokumen,
} from "../../api";

import TableNew, {
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "../../components/layouts/TableNew";

import PageLoading from "../../components/pages/Loading";
import PageNoData from "../../components/pages/NoData";
import LayoutModal from "../../components/layouts/Modal";

import {
  saToast,
} from "../../helpers";

import { titleState } from "../../storage/pages";


const WisudaTerdaftar = () => {

  const setTitle =
    useSetRecoilState(titleState);


  // =========================================================
  // STATE
  // =========================================================

  const [isLoaded, setIsLoaded] =
    useState(false);

  const [items, setItems] =
    useState([]);

  const [search, setSearch] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const [itemsPerPage, setItemsPerPage] =
    useState(10);


  // =========================================================
  // DETAIL
  // =========================================================

  const [detail, setDetail] =
    useState(null);

  const [detailModal, setDetailModal] =
    useState(false);


  // =========================================================
  // DOCUMENT
  // =========================================================

  const [documentUrl, setDocumentUrl] =
    useState(null);

  const [documentMimeType, setDocumentMimeType] =
    useState(null);

  const [documentLoading, setDocumentLoading] =
    useState(false);

  const [documentModal, setDocumentModal] =
    useState(false);


  // =========================================================
  // TITLE
  // =========================================================

  useEffect(() => {

    setTitle(
      "Mahasiswa Terdaftar Wisuda"
    );

  }, [setTitle]);


  // =========================================================
  // FETCH DATA
  // =========================================================

  const fetchData = useCallback(
    async () => {

      try {

        setIsLoaded(false);

        const res =
          await fetchWisudaTerdaftar();

        console.log(
          "Wisuda Terdaftar:",
          res.data
        );

        setItems(
          res?.data?.data || []
        );

      } catch (err) {

        console.log(
          "Error fetch wisuda terdaftar:",
          err
        );

        saToast(
          "error",
          err?.response?.data?.message ||
            "Gagal mengambil data mahasiswa terdaftar."
        );

      } finally {

        setIsLoaded(true);

      }

    },
    []
  );


  useEffect(() => {

    fetchData();

  }, [fetchData]);


  // =========================================================
  // RESET PAGE
  // =========================================================

  useEffect(() => {

    setCurrentPage(1);

  }, [
    search,
    itemsPerPage,
  ]);


  // =========================================================
  // SEARCH
  // =========================================================

  const filteredItems =
    items.filter((item) => {

      const mahasiswa =
        item?.mahasiswa;

      const nim =
        String(
          mahasiswa?.nim ||
            mahasiswa?.NIM ||
            ""
        ).toLowerCase();

      const nama =
        String(
          mahasiswa?.nama ||
            ""
        ).toLowerCase();

      const keyword =
        search
          .toLowerCase()
          .trim();

      if (!keyword) {
        return true;
      }

      return (
        nim.includes(keyword) ||
        nama.includes(keyword)
      );

    });


  // =========================================================
  // PAGINATION
  // =========================================================

  const totalItems =
    filteredItems.length;

  const totalPages =
    Math.ceil(
      totalItems / itemsPerPage
    );

  const startIndex =
    (currentPage - 1) *
    itemsPerPage;

  const endIndex =
    startIndex +
    itemsPerPage;

  const paginatedItems =
    filteredItems.slice(
      startIndex,
      endIndex
    );


  // =========================================================
  // DETAIL
  // =========================================================

  const handleDetail =
    async (id) => {

      try {

        const res =
          await showWisudaTerdaftar(
            id
          );

        console.log(
          "Detail wisuda terdaftar:",
          res.data
        );

        setDetail(
          res?.data?.data || null
        );

        setDetailModal(true);

      } catch (err) {

        console.log(
          "Error detail:",
          err
        );

        saToast(
          "error",
          err?.response?.data?.message ||
            "Gagal mengambil detail mahasiswa."
        );

      }

    };


  // =========================================================
  // CLOSE DETAIL
  // =========================================================

  const handleCloseDetail =
    () => {

      setDetailModal(false);
      setDetail(null);

    };


  // =========================================================
  // VIEW DOCUMENT
  // =========================================================

  const handleViewDocument =
    async (dokumenId) => {

      if (!dokumenId) {

        saToast(
          "warning",
          "Dokumen tidak tersedia."
        );

        return;
      }

      try {

        setDocumentLoading(true);
        setDocumentModal(true);

        const res =
          await getWisudaDokumen(
            dokumenId
          );

        const mimeType =
          res?.headers?.[
            "content-type"
          ] ||
          "application/pdf";

        const blob =
          new Blob(
            [res.data],
            {
              type: mimeType,
            }
          );

        const url =
          window.URL.createObjectURL(
            blob
          );

        setDocumentUrl(url);
        setDocumentMimeType(
          mimeType
        );

      } catch (err) {

        console.log(
          "Error dokumen:",
          err
        );

        setDocumentModal(false);

        saToast(
          "error",
          err?.response?.data?.message ||
            "Dokumen tidak dapat dibuka."
        );

      } finally {

        setDocumentLoading(false);

      }

    };


  // =========================================================
  // CLOSE DOCUMENT
  // =========================================================

  const handleCloseDocument =
    () => {

      if (documentUrl) {

        window.URL.revokeObjectURL(
          documentUrl
        );

      }

      setDocumentUrl(null);
      setDocumentMimeType(null);
      setDocumentModal(false);

    };


  // =========================================================
  // STATUS PENDAFTARAN
  // =========================================================

  const getStatusLabel =
    (status) => {

      switch (status) {

        case "registered":
          return "Terdaftar";

        default:
          return status || "-";

      }

    };


  const getStatusClass =
    (status) => {

      switch (status) {

        case "registered":
          return "badge bg-success";

        default:
          return "badge bg-secondary";

      }

    };


  // =========================================================
  // STATUS APPROVAL
  // =========================================================

  const getApprovalStatusLabel =
    (status) => {

      switch (status) {

        case "approved":
          return "Disetujui";

        case "pending":
          return "Menunggu Verifikasi";

        case "rejected":
          return "Ditolak";

        default:
          return status || "-";

      }

    };


  const getApprovalStatusClass =
    (status) => {

      switch (status) {

        case "approved":
          return "badge bg-success";

        case "pending":
          return "badge bg-warning text-dark";

        case "rejected":
          return "badge bg-danger";

        default:
          return "badge bg-secondary";

      }

    };


  // =========================================================
  // FORMAT DATE
  // =========================================================

  const formatDateTime =
    (value) => {

      if (!value) {
        return "-";
      }

      const date =
        new Date(value);

      if (
        Number.isNaN(
          date.getTime()
        )
      ) {
        return value;
      }

      return date.toLocaleString(
        "id-ID",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      );

    };


  // =========================================================
  // PAGINATION NUMBER
  // =========================================================

  const getPageNumbers =
    () => {

      const pages = [];

      if (totalPages <= 7) {

        for (
          let page = 1;
          page <= totalPages;
          page++
        ) {

          pages.push(page);

        }

        return pages;
      }


      pages.push(1);


      if (currentPage > 4) {

        pages.push("left-ellipsis");

      }


      const startPage =
        Math.max(
          2,
          currentPage - 2
        );

      const endPage =
        Math.min(
          totalPages - 1,
          currentPage + 2
        );


      for (
        let page = startPage;
        page <= endPage;
        page++
      ) {

        pages.push(page);

      }


      if (
        currentPage <
        totalPages - 3
      ) {

        pages.push(
          "right-ellipsis"
        );

      }


      pages.push(totalPages);

      return pages;

    };


  // =========================================================
  // LOADING
  // =========================================================

  if (!isLoaded) {

    return <PageLoading />;

  }


  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>

      {/* =====================================================
          HEADER
      ====================================================== */}

      <div className="row mb-3">

        <div className="col-md">

          <h5 className="font-weight-bold mb-1">

            Mahasiswa Terdaftar Wisuda

          </h5>

          <small className="text-muted">

            Daftar mahasiswa yang seluruh
            persyaratan wisudanya telah
            disetujui.

          </small>

        </div>

      </div>


      {/* =====================================================
          SEARCH
      ====================================================== */}

      <div className="row mb-3">

        <div className="col-md-6">

          <div className="input-group">

            <input
              type="text"
              className="form-control"
              placeholder="Cari berdasarkan NIM atau nama mahasiswa..."
              value={search}
              onChange={(e) =>
                setSearch(
                  e.target.value
                )
              }
            />

            {search && (

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() =>
                  setSearch("")
                }
              >

                <i className="fa fa-times" />

              </button>

            )}

          </div>

        </div>


        <div className="col-md-6 text-right">

          <div className="d-inline-flex align-items-center">

            <span className="mr-2">
              Tampilkan
            </span>

            <select
              className="form-control form-control-sm"
              value={itemsPerPage}
              onChange={(e) =>
                setItemsPerPage(
                  Number(
                    e.target.value
                  )
                )
              }
              style={{
                width: "80px",
              }}
            >

              <option value={10}>
                10
              </option>

              <option value={25}>
                25
              </option>

              <option value={50}>
                50
              </option>

              <option value={100}>
                100
              </option>

            </select>

            <span className="ml-2">
              data
            </span>

          </div>

        </div>

      </div>


      {/* =====================================================
          SEARCH RESULT
      ====================================================== */}

      {search && (

        <div className="mb-2">

          <small className="text-muted">

            Hasil pencarian:

            {" "}

            <strong>
              {search}
            </strong>

            {" "}
            ({totalItems} data)

          </small>

        </div>

      )}


      {/* =====================================================
          TABLE
      ====================================================== */}

      {paginatedItems.length > 0 ? (

        <TableNew>

          <Thead>

            <Tr className="text-center">

              <Th>
                No
              </Th>

              <Th>
                No. Pendaftaran
              </Th>

              <Th>
                NIM
              </Th>

              <Th>
                Nama Mahasiswa
              </Th>

              <Th>
                Tanggal Daftar
              </Th>

              <Th>
                Tanggal Approve
              </Th>

              <Th>
                Status
              </Th>

              <Th>
                Aksi
              </Th>

            </Tr>

          </Thead>


          <Tbody>

            {paginatedItems.map(
              (item, index) => {

                const mahasiswa =
                  item?.mahasiswa;


                return (

                  <Tr
                    key={item.id}
                  >

                    <Td className="text-center">

                      {startIndex +
                        index +
                        1}

                    </Td>


                    <Td>

                      {
                        item?.nomor_pendaftaran ||
                        "-"
                      }

                    </Td>


                    <Td>

                      {
                        mahasiswa?.nim ||
                        mahasiswa?.NIM ||
                        "-"
                      }

                    </Td>


                    <Td>

                      {
                        mahasiswa?.nama ||
                        "-"
                      }

                    </Td>


                    <Td>

                      {
                        formatDateTime(
                          item?.tanggal_daftar
                        )
                      }

                    </Td>


                    <Td>

                      {
                        formatDateTime(
                          item?.registered_at
                        )
                      }

                    </Td>


                    <Td className="text-center">

                      <span
                        className={
                          getStatusClass(
                            item?.status
                          )
                        }
                      >

                        {
                          getStatusLabel(
                            item?.status
                          )
                        }

                      </span>

                    </Td>


                    <Td className="text-center">

                      <button
                        type="button"
                        className="btn btn-sm btn-primary py-0 px-2"
                        onClick={() =>
                          handleDetail(
                            item.id
                          )
                        }
                      >

                        <i className="fa fa-fw fa-eye" />

                        &nbsp;

                        Detail

                      </button>

                    </Td>

                  </Tr>

                );

              }
            )}

          </Tbody>

        </TableNew>

      ) : (

        <PageNoData />

      )}


      {/* =====================================================
          PAGINATION INFO
      ====================================================== */}

      {totalItems > 0 && (

        <div className="row mt-3">

          <div className="col-md-6">

            <small className="text-muted">

              Menampilkan{" "}

              {startIndex + 1}

              {" - "}

              {Math.min(
                endIndex,
                totalItems
              )}

              {" dari "}

              {totalItems}

              {" data"}

            </small>

          </div>


          {/* =================================================
              PAGINATION
          ================================================== */}

          <div className="col-md-6">

            {totalPages > 1 && (

              <div className="d-flex justify-content-end">

                <nav>

                  <ul className="pagination pagination-sm mb-0">

                    {/* PREVIOUS */}

                    <li
                      className={`page-item ${
                        currentPage === 1
                          ? "disabled"
                          : ""
                      }`}
                    >

                      <button
                        type="button"
                        className="page-link"
                        disabled={
                          currentPage === 1
                        }
                        onClick={() =>
                          setCurrentPage(
                            (prev) =>
                              Math.max(
                                prev - 1,
                                1
                              )
                          )
                        }
                      >

                        &laquo;

                      </button>

                    </li>


                    {/* PAGE NUMBERS */}

                    {getPageNumbers().map(
                      (page) => {

                        if (
                          page ===
                          "left-ellipsis"
                        ) {

                          return (

                            <li
                              key={
                                page
                              }
                              className="page-item disabled"
                            >

                              <span className="page-link">
                                ...
                              </span>

                            </li>

                          );

                        }


                        if (
                          page ===
                          "right-ellipsis"
                        ) {

                          return (

                            <li
                              key={
                                page
                              }
                              className="page-item disabled"
                            >

                              <span className="page-link">
                                ...
                              </span>

                            </li>

                          );

                        }


                        return (

                          <li
                            key={
                              page
                            }
                            className={`page-item ${
                              currentPage ===
                              page
                                ? "active"
                                : ""
                            }`}
                          >

                            <button
                              type="button"
                              className="page-link"
                              onClick={() =>
                                setCurrentPage(
                                  page
                                )
                              }
                            >

                              {page}

                            </button>

                          </li>

                        );

                      }
                    )}


                    {/* NEXT */}

                    <li
                      className={`page-item ${
                        currentPage ===
                        totalPages
                          ? "disabled"
                          : ""
                      }`}
                    >

                      <button
                        type="button"
                        className="page-link"
                        disabled={
                          currentPage ===
                          totalPages
                        }
                        onClick={() =>
                          setCurrentPage(
                            (prev) =>
                              Math.min(
                                prev + 1,
                                totalPages
                              )
                          )
                        }
                      >

                        &raquo;

                      </button>

                    </li>

                  </ul>

                </nav>

              </div>

            )}

          </div>

        </div>

      )}


      {/* =====================================================
          DETAIL MODAL
      ====================================================== */}

      <LayoutModal
        title="Detail Mahasiswa Terdaftar"
        modal={
          detailModal
        }
        onClose={
          handleCloseDetail
        }
      >

        {detail && (

          <>

            {/* =================================================
                DATA MAHASISWA
            ================================================== */}

            <div className="row">

              <div className="col-md-6">

                <label className="font-weight-bold">
                  No. Pendaftaran
                </label>

                <div>

                  {
                    detail?.nomor_pendaftaran ||
                    "-"
                  }

                </div>

              </div>


              <div className="col-md-6">

                <label className="font-weight-bold">
                  Status
                </label>

                <div>

                  <span
                    className={
                      getStatusClass(
                        detail?.status
                      )
                    }
                  >

                    {
                      getStatusLabel(
                        detail?.status
                      )
                    }

                  </span>

                </div>

              </div>

            </div>


            <div className="row mt-3">

              <div className="col-md-4">

                <label className="font-weight-bold">
                  NIM
                </label>

                <div>

                  {
                    detail?.mahasiswa?.nim ||
                    detail?.mahasiswa?.NIM ||
                    "-"
                  }

                </div>

              </div>


              <div className="col-md-8">

                <label className="font-weight-bold">
                  Nama Mahasiswa
                </label>

                <div>

                  {
                    detail?.mahasiswa?.nama ||
                    "-"
                  }

                </div>

              </div>

            </div>


            <hr />


            {/* =================================================
                PERSYARATAN
            ================================================== */}

            <h6 className="font-weight-bold mb-3">

              Persyaratan Wisuda

            </h6>


            {detail?.approvals?.length > 0 ? (

              [...detail.approvals]
                .sort(
                  (a, b) =>
                    (
                      a?.persyaratan?.urutan ||
                      0
                    ) -
                    (
                      b?.persyaratan?.urutan ||
                      0
                    )
                )
                .map(
                  (
                    approval,
                    index
                  ) => {

                    const dokumen =
                      approval?.dokumen;

                    const persyaratan =
                      approval?.persyaratan;


                    return (

                      <div
                        key={
                          approval.id
                        }
                        className="border rounded p-3 mb-3"
                      >

                        <div className="row align-items-start">

                          {/* NO */}

                          <div className="col-md-1 text-center">

                            <strong>

                              {
                                index +
                                1
                              }

                            </strong>

                          </div>


                          {/* PERSYARATAN */}

                          <div className="col-md-7">

                            <div className="font-weight-bold">

                              {
                                persyaratan?.nama ||
                                "-"
                              }

                            </div>


                            {persyaratan?.deskripsi && (

                              <small className="text-muted">

                                {
                                  persyaratan.deskripsi
                                }

                              </small>

                            )}

                          </div>


                          {/* STATUS */}

                          <div className="col-md-4 text-md-right">

                            <span
                              className={
                                getApprovalStatusClass(
                                  approval?.status
                                )
                              }
                            >

                              {
                                getApprovalStatusLabel(
                                  approval?.status
                                )
                              }

                            </span>

                          </div>

                        </div>


                        {/* =================================================
                            DOCUMENT
                        ================================================== */}

                        {dokumen && (

                          <div className="mt-3 pt-2 border-top">

                            <small className="text-muted">

                              Dokumen:

                            </small>


                            <div className="mt-1">

                              {
                                dokumen?.nama_file_original ||
                                dokumen?.nama_file ||
                                "-"
                              }

                            </div>


                            <button
                              type="button"
                              className="btn btn-sm btn-info mt-2"
                              onClick={() =>
                                handleViewDocument(
                                  dokumen.id
                                )
                              }
                            >

                              <i className="fa fa-fw fa-file-pdf" />

                              &nbsp;

                              Lihat Dokumen

                            </button>

                          </div>

                        )}

                      </div>

                    );

                  }
                )

            ) : (

              <div className="text-muted">

                Data persyaratan tidak tersedia.

              </div>

            )}

          </>

        )}

      </LayoutModal>


      {/* =====================================================
          DOCUMENT MODAL
      ====================================================== */}

      <LayoutModal
        title="Dokumen Persyaratan Wisuda"
        modal={
          documentModal
        }
        onClose={
          handleCloseDocument
        }
      >

        {documentLoading ? (

          <div className="text-center p-4">

            <i className="fa fa-spinner fa-spin" />

            &nbsp;

            Memuat dokumen...

          </div>

        ) : documentUrl ? (

          documentMimeType?.startsWith(
            "image/"
          ) ? (

            <div className="text-center">

              <img
                src={
                  documentUrl
                }
                alt="Dokumen"
                style={{
                  maxWidth:
                    "100%",
                  maxHeight:
                    "70vh",
                }}
              />

            </div>

          ) : (

            <iframe
              src={
                documentUrl
              }
              title="Dokumen Wisuda"
              style={{
                width:
                  "100%",
                height:
                  "70vh",
                border:
                  "none",
              }}
            />

          )

        ) : (

          <div className="text-center text-muted">

            Dokumen tidak tersedia.

          </div>

        )}

      </LayoutModal>

    </>
  );

};


export default WisudaTerdaftar;